import { render } from "./AddPostPage.vue?vue&type=template&id=6d0b0566"
import script from "./AddPostPage.vue?vue&type=script&lang=js"
export * from "./AddPostPage.vue?vue&type=script&lang=js"
script.render = render

export default script